import initialState from './initialState';
import * as catalogApi from '../logic/api/catalog';

export const getModels = (brandId) => (dispatch, getState) => {
  dispatch({
    type: 'CATALOG:GET-MODELS'
  });

  catalogApi.fetchCatalog(brandId)
  .then((res) => {

    let brand = res.brands[0] === undefined ? getState().catalogReducer.brand : res.brands[0];

    dispatch(chooseBrand(brand));
    dispatch(onGetModelsSuccess(res.models));
  })
  .catch((err) => dispatch(onGetModelsErr(err)));
};


export const onGetModelsSuccess = (modelList) => ({
  type: 'CATALOG:GET-MODELS-SUCCESS',
  modelList: modelList
});

export const onGetModelsErr = (err) => ({
  type: 'CATALOG:GET-MODELS-ERR',
  err
});

export const chooseBrand = (brand) => ({
  type: 'CATALOG:CHOOSE-BRAND',
  brand: brand
});

export const getModifications = (modelId) => (dispatch, getState) => {
  dispatch({
    type: 'CATALOG:GET-MODIFICATIONS'
  });

  catalogApi.fetchModifications(modelId)
    .then((res) => {

      let brand = res.brands[0] === undefined ? getState().catalogReducer.brand : res.brands[0];
      let model = res.models[0] === undefined ? getState().catalogReducer.model : res.models[0];

      dispatch(chooseBrand(brand));
      dispatch(chooseModel(model));
      dispatch(onGetModificationsSuccess(res.modifications));
    })
    .catch((err) => dispatch(onGetModificationsErr(err)));
};

export const onGetModificationsSuccess = (modificationList) => ({
  type: 'CATALOG:GET-MODIFICATIONS-SUCCESS',
  modificationList: modificationList
});

export const onGetModificationsErr = (err) => ({
  type: 'CATALOG:GET-MODIFICATIONS-ERR',
  err
});

export const getMaintenanceDetails = (modificationId) => (dispatch, getState) => {
  dispatch({
    type: 'CATALOG:GET-MAINTENANCE-DETAILS'
  });

  catalogApi.fetchMaintenanceDetails(modificationId)
    .then((res) => {

      let brand = res.brands[0] === undefined ? getState().catalogReducer.brand : res.brands[0];
      let model = res.models[0] === undefined ? getState().catalogReducer.model : res.models[0];

      dispatch(chooseBrand(brand));
      dispatch(chooseModel(model));
      dispatch(chooseModification(res.modifications[0]));
      dispatch(onGetMaintenanceDetailsSuccess(res.maintenanceDetails));
    })
    .catch((err) => dispatch(onGetMaintenanceDetailsErr(err)));
};

export const onGetMaintenanceDetailsSuccess = (maintenanceDetailList) => ({
  type: 'CATALOG:GET-MAINTENANCE-DETAILS-SUCCESS',
  maintenanceDetailList: maintenanceDetailList
});

export const onGetMaintenanceDetailsErr = (err) => ({
  type: 'CATALOG:GET-MAINTENANCE-DETAILS-ERR',
  err
});

export const chooseModel = (model) => ({
  type: 'CATALOG:CHOOSE-MODEL',
  model: model
});

export const chooseModification = (modification) => ({
  type: 'CATALOG:CHOOSE-MODIFICATION',
  modification: modification
});

export default function catalogReducer(state = initialState.catalogState, action) {
  switch(action.type) {

    case 'CATALOG:GET-MODELS-SUCCESS':
      return {
        ...state,
        modelList: action.modelList
      };

    case 'CATALOG:CHOOSE-BRAND':
      return {
        ...state,
        brand: action.brand
      };

    case 'CATALOG:GET-MODIFICATIONS-SUCCESS':
      return {
        ...state,
        modificationList: action.modificationList
      };

    case 'CATALOG:GET-MAINTENANCE-DETAILS-SUCCESS':
      return {
        ...state,
        maintenanceDetailList: action.maintenanceDetailList
      };

    case 'CATALOG:CHOOSE-MODEL':
      return {
        ...state,
        model: action.model
      };

    case 'CATALOG:CHOOSE-MODIFICATION':
      return {
        ...state,
        modification: action.modification
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/catalogActions.js
 **/